// extracted by mini-css-extract-plugin
export var h1 = "styles-module--h1--fc654";
export var h2 = "styles-module--h2--c6507";
export var h3 = "styles-module--h3--ba15a";
export var h4 = "styles-module--h4--5fcf8";
export var h5 = "styles-module--h5--d757d";
export var text = "styles-module--text--2ebc4";